import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const MembershipInfo = () => {
  const navigate = useNavigate();

  // Redirect to the new registration page
  useEffect(() => {
    console.log('MembershipInfo: Redirecting to registration page');
    navigate('/register', { replace: true });
  }, [navigate]);

  // This component now just redirects, but keeping the JSX for safety
  // Membership tiers data (legacy - not used anymore)
  const membershipTiers = [
    {
      id: 1,
      name: 'Tier 1',
      price: '$75.00 per Year',
      description: 'Analysts & Associates with less than three years of experience (also referred to as recent undergraduates).'
    },
    {
      id: 2,
      name: 'Tier 2',
      price: '$125.00 per Year',
      description: 'Analysts & Associates with more than three years of experience.'
    },
    {
      id: 3,
      name: 'Tier 3',
      price: '$175.00 per Year',
      description: 'Managers, VP\'s, Directors, and Managing Directors.'
    },
    {
      id: 4,
      name: 'Tier 4',
      price: '$225.00 per Year',
      description: 'C-suite Executives, Principals, Partners, and Business Owners.'
    },
    {
      id: 5,
      name: 'Tier USV',
      price: '$75.00 per Year',
      description: 'US Veterans, regardless of seniority level.'
    }
  ];

  return (
    <div className="bg-white">
      {/* Page Header */}
      <div className="bg-apn-blue text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* APN Logo */}
            <div className="flex justify-center mb-4">
              <img
                src={`${process.env.PUBLIC_URL}/apn-logos/APN-Tag-white.jpg`}
                alt="APN Logo"
                className="h-16"
              />
            </div>
            <h1 className="text-3xl font-bold">Membership Information</h1>
          </div>
        </div>
      </div>

      {/* Membership Content */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Accelerate your Career with APN</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We are glad you are considering membership with APN! Becoming a member of APN will grant you access to a variety of features including member forums, groups, job boards, project inquiry boards, member directories, and more.
            </p>
          </div>

          <div className="mb-12">
            <p className="text-lg text-gray-600 mb-4">
              Membership with APN is on a "Tier" system. Your Tier will not prevent you from attending or accessing APN events. Please make sure you are signing up for the correct tier as registration is monitored, evaluated, and approved by APN staff.
            </p>
            <p className="text-lg text-gray-600">
              If your exact role is not listed, please choose the one closest to your current title. If you are an Independent Contractor or currently between roles, please choose the title that you are applying to jobs for or the closest to your seniority level. Should you have any questions, please email info@the-apn.com.
            </p>
          </div>

          {/* Membership Tiers */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {membershipTiers.map((tier) => (
              <div key={tier.id} className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                <div className="bg-apn-blue text-white p-6">
                  <h3 className="text-2xl font-bold">{tier.name}</h3>
                  <p className="text-xl mt-2">{tier.price}</p>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 mb-6">{tier.description}</p>
                  <Link 
                    to="/register" 
                    className="block w-full bg-apn-blue text-white text-center py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
                  >
                    Select
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-apn-blue text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* APN Logo */}
          <div className="flex justify-center mb-6">
            <img
              src={`${process.env.PUBLIC_URL}/apn-logos/APN-Tag-SQ-white.jpg`}
              alt="APN Logo Square"
              className="h-20"
            />
          </div>
          <h2 className="text-3xl font-bold mb-4">Ready to Join the Network?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Connect with finance professionals, access exclusive resources, and accelerate your career with APN.
          </p>
          <Link to="/register" className="btn-primary bg-white text-apn-blue hover:bg-gray-100">
            Become a Member Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default MembershipInfo;
